export default "__VITE_ASSET__DmdGc$4t__"